import VideoImage from './videoImage';
import VideoModal from './videoModal';
import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

const VideoRenderer = (function() {
  function videoPresent(video) {
    if (!video) return false;

    return video.id && video.src;
  }

  function renderVideoModal(video) {
    if (videoPresent(video)) {
      const videoModal = document.createElement('div');
      $(videoModal).appendTo('body');
      ReactDOM.render(<VideoModal id={`video-modal-${video.id}`} src={video.src} />, videoModal);
    }
  }

  function renderVideoImage(video, imageVideoUrl, imageVideoAlt) {
    if (!videoPresent(video)) return null;

    return (
      <div className="video-image-container">
        <VideoImage id={video.id} url={imageVideoUrl} alt={imageVideoAlt} />
      </div>
    );
  }

  return {
    renderVideoModal,
    renderVideoImage
  };
})();

export default VideoRenderer;



// WEBPACK FOOTER //
// ./components/videos/videoRenderer.js